'use strict';

export default class Form {
  constructor() {
    // Add fieldset and legend element to the form for each group of radio buttons
    this.addFieldsetAndLegendToGroupRadio();

    // Add label and id to hidden input on /subscribe
    this.addLabelAndIdToHiddenInput();

    // Add associated label for textarea g-recaptcha because all textarea elements must have an explicitly associated label
    setTimeout(() => {
      this.addLabelsToTextareas();
    }, 1000);

    // Change id of search form mobile because id attributes must be unique
    this.changeIdOfSearchFormMobile();
  }

  addFieldsetAndLegendToGroupRadio() {
    var fieldGroup = $('.mc-field-group.input-group');
    var fieldset = $('<fieldset></fieldset>');
    var legend = $('<legend></legend>').text('Choose the option that best describes you:');
    fieldset.append(legend);
    fieldset.append(fieldGroup.children().not('strong'));
    fieldGroup.empty().append(fieldset);
  }

  addLabelAndIdToHiddenInput() {
    var hiddenDiv = $('div[aria-hidden="true"][style*="position: absolute; left: -5000px;"]');
    var input = hiddenDiv.find('input');
    var inputId = input.attr('id');
    if (!inputId) {
      inputId = 'hidden-input-form-subscribe';
      input.attr('id', inputId);
    }
    var label = $('<label></label>').attr('for', inputId).text('Hidden Input Label');
    input.before(label);
  }

  addLabelsToTextareas() {
    var textareas = $('textarea#g-recaptcha-response');
    if (textareas.length) {
      textareas.each(function () {
        var textarea = $(this);
        var textareaId = textarea.attr('id');
        if ($('label[for="' + textareaId + '"]').length === 0) {
          var label = $('<label></label>').attr('for', textareaId).text('Recaptcha Response');
          textarea.before(label);
        }
      });
    }
  }

  changeIdOfSearchFormMobile() {
    var mobileBlock = $('.region-search-mobile #block-ric-exposedformglobal-searchpage-1');
    if (mobileBlock.length) {
      mobileBlock.attr('id', 'block-ric-exposedformglobal-searchpage-1-mobile');
    }
    var mobileForm = $('.region-search-mobile #views-exposed-form-global-search-page-1');
    if (mobileForm.length) {
      mobileForm.attr('id', 'views-exposed-form-global-search-page-1-mobile');
    }
  }
}
